import { useForm } from "react-hook-form";
import MainContainer from "../../components/container/MainContainer";
import InputField from "../../components/form/InputField";
import { getDate, getTodayDate } from "../../util";
import NumberInputField from "../../components/form/NumberInputField";
import TextAreaField from "../../components/form/TextAreaField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
const JournalTransfer = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    try {
      e.preventDefault();
    } catch (error) {}
  };
  return (
    <MainContainer className="bg-content border border-bkg2">
      <h3 className="p-3">Journal Transfer</h3>
      <form
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col sm:px-10 "
      >
        <ResourseButtons link to="/accounts/transaction" />
      </form>
    </MainContainer>
  );
};

export default JournalTransfer;
